import i18next from 'i18next';
import { z } from 'zod';

const passwordValidation = z.string().min(8).max(64);

const confirmPasswordRefine = (
  data: { new_password: string; confirm_password: string },
  ctx: z.RefinementCtx,
) => {
  if (data.new_password !== data.confirm_password) {
    ctx.addIssue({
      code: 'custom',
      path: ['confirm_password'],
      message: i18next.t('auth.change-password.confirm-password-mismatch'),
    });
  }
};

/**
 * 初回パスワード設定フォームのバリデーションスキーマ（全画面ページ用）
 *
 * FEでは文字数のみ検証し、文字種要件はBEに委任する
 */
export const changeFirstPasswordSchema = z
  .object({
    new_password: passwordValidation,
    confirm_password: z.string().min(1),
  })
  .superRefine(confirmPasswordRefine);

export type ChangeFirstPasswordFormData = z.infer<typeof changeFirstPasswordSchema>;

/**
 * パスワード変更フォームのバリデーションスキーマ（ダイアログ用）
 *
 * FEでは文字数のみ検証し、文字種要件はBEに委任する
 */
export const changePasswordSchema = z
  .object({
    current_password: z.string().min(1),
    new_password: passwordValidation,
    confirm_password: z.string().min(1),
  })
  .superRefine(confirmPasswordRefine);

export type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;
